import { ButtonGroup as AriesButtonGroup, Modal } from 'glints-aries/es/@next';
import { large } from 'glints-aries/es/@next/utilities/breakpoints';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';
import {
  space8,
  space16,
  space24,
  space40,
} from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  width: 600px;

  @media (max-width: ${large}) {
    width: 100vw;
  }

  .modal-content {
    box-sizing: border-box;
    width: 100%;
    padding: 0;
    background: linear-gradient(180deg, ${Blue.S08} 0%, ${Neutral.B100} 45%);
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${space40} ${space16} ${space16};
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space16};
  right: ${space16};
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

export const Illustration = styled.img`
  width: 72px;
  height: 72px;
  margin-bottom: ${space16};
`;

export const Description = styled.div`
  max-width: 440px;
  margin-top: ${space8};
  margin-bottom: ${space24};
`;

export const ButtonGroup = styled(AriesButtonGroup)`
  width: 100%;

  @media (max-width: ${large}) {
    flex-direction: column;
    align-items: stretch;
  }
`;
